import Vue from 'vue';

export default new Vue();

export const RegionStore = Vue.observable({
    selectedProvince: null
});